import { Observable, tap } from 'rxjs';
import { SystemsRepositoryPort } from 'common/systems/application/ports/systems-repository.port';
import { SystemsStatePort } from 'common/systems/application/ports/systems-state.port';
import { System } from 'common/systems/domain/resources/system.resource';

export class LoadSystemsUseCase {
    public constructor(
        private readonly systemsRepositoryPort: SystemsRepositoryPort,
        private readonly systemsStatePort: SystemsStatePort,
    ) {}

    public execute(): Observable<ReadonlyArray<System>> {
        return this.systemsRepositoryPort
            .getAll()
            .pipe(
                tap((updatedSystems: ReadonlyArray<System>): void =>
                    this.systemsStatePort.applyUpdate(updatedSystems),
                ),
            );
    }
}
